module.exports = __webpack_public_path__ + "img/letsbutterfly-wings-winglet.35ea495d.png";